import React from "react";
import PropTypes from 'prop-types';

import style from "./Testimonial.css";

const Testimonial = ({ team }) => {
  const member = team.members ? team.members[0] : {};
  const image = `url(${member.image})`;

  return (
    <div className={style.testimonial}>
      <div className={style.member}>
        <div className={style.image} style={{ backgroundImage: image }} />
        <div className={style.info}>
          <h3 className={style.name}>{member.name}</h3>
          <span className={style.role}>{member.role}</span>
        </div>
      </div>
      <div className={style.quote}>
        <p>{member.quote}</p>
      </div>
    </div>
  );
};

Testimonial.propTypes = {
  team: PropTypes.object.isRequired
};

export default Testimonial;




// WEBPACK FOOTER //
// ./component/TeamList/Testimonial.js